import { render, staticRenderFns } from "./userhome.vue?vue&type=template&id=1f3f7098&scoped=true"
import script from "./userhome.vue?vue&type=script&lang=js"
export * from "./userhome.vue?vue&type=script&lang=js"
import style0 from "./userhome.vue?vue&type=style&index=0&id=1f3f7098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3f7098",
  null
  
)

export default component.exports